import { Component, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MeetingRecordComponent } from 'src/app/components/main/shared/meeting-record/meeting-record.component';
import { ComponentCanDeactivate } from 'src/app/guards/pending-changes.guard';

@Component({
  selector: 'app-potential-client-meeting-record',
  templateUrl: './potential-client-meeting-record.component.html',
  styleUrls: [
    './potential-client-meeting-record.component.css',
    '../../../../../shared/meeting-record/meeting-record-parent-shell.styles.css',
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MeetingRecordComponent],
})
export class PotentialClientMeetingRecordComponent implements ComponentCanDeactivate {
  protected activatedRoute = inject(ActivatedRoute);

  @ViewChild(MeetingRecordComponent) childComponent: MeetingRecordComponent;
  meetingableType: 'App\\Models\\User' | 'App\\Models\\CompanyProduct' | 'App\\Models\\PotentialClient' = 'App\\Models\\PotentialClient';
  meetingableId: number;
  meetingRecordId: number;

  get isCreate() {
    return this.meetingRecordId == null;
  }

  constructor() {
    this.meetingableId = +(this.activatedRoute.snapshot.paramMap.get('id') as string);
    this.meetingRecordId = +(this.activatedRoute.snapshot.paramMap.get('meeting_id') as string);
  }

  canDeactivate(): Observable<boolean> | boolean {
    return this.childComponent.canDeactivate();
  }
}
